const travelMap = {
  state: {
    travelMapInfo: {}
  },
  mutations: {
    SET_TRAVEL_MAP_INFO: (state, travelMapInfo) => {
      state.travelMapInfo = travelMapInfo
    }
  }
}
export default travelMap



// WEBPACK FOOTER //
// ./src/store/modules/travelMap.js